import { useState } from 'react'
import { ImageInterface } from '../../components/History/ImagesHistoryList'
import { useParams } from 'react-router-dom'
import { useGenerateUploadUrlService, useUploadFileService } from 'services/useFileService'
import { useAppModeContext } from 'context/AppModeContext'

const useImagesHistory = () => {
    const { id } = useParams()
    const { account_id } = useAppModeContext()
    const imagesHistoryStorage = `imagesHistory-${id}-${account_id}`

    const [image, setImage] = useState<ImageInterface>()

    const { generateUploadUrlService } = useGenerateUploadUrlService()
    const { uploadFileService } = useUploadFileService()

    const saveImage = (newImage: ImageInterface) => {
        setImage(newImage)

        const imagesStorage = JSON.parse(localStorage.getItem(imagesHistoryStorage) || '[]')
        imagesStorage.unshift(newImage)
        localStorage.setItem(imagesHistoryStorage, JSON.stringify(imagesStorage))
    }

    const uploadBlobUrl = async (blobUrl: string) => {
        try {
            const response = await fetch(blobUrl)
            const blob = await response.blob()
            const file = new File([blob], 'uploaded_blob.png', { type: blob.type })

            const data = {
                name: file.name,
                type: file.type,
                size: file.size,
            }

            const { signed_url, file_url } = await generateUploadUrlService(data)

            await uploadFileService(signed_url, file)

            return file_url
        } catch (error) {
            return null
        }
    }

    const uploadBase64Image = async (base64String: string) => {
        try {
            // Remove the data URL prefix if present
            const base64Data = base64String.replace(/^data:image\/\w+;base64,/, '')
            const byteCharacters = atob(base64Data)
            const byteNumbers = new Array(byteCharacters.length)

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }

            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], { type: 'image/png' })
            const file = new File([blob], 'uploaded_base64.png', { type: blob.type })

            const data = {
                name: file.name,
                type: file.type,
                size: file.size,
            }

            const { signed_url, file_url } = await generateUploadUrlService(data)

            await uploadFileService(signed_url, file)

            return file_url
        } catch (error) {
            return null
        }
    }

    return { image, saveImage, uploadBlobUrl, uploadBase64Image }
}

export default useImagesHistory
